<div *ngIf="shown.length" class="problem-scroll flex flex-col gap-2 mb-2">
  <div *ngFor="let problem of shown"
       class="problem-row flex gap-3 p-3 rounded-lg"
       [class.blocking]="isBlockingProblem(problem)">
    <span class="severity-dot mt-1.5" [class.blocking]="isBlockingProblem(problem)"></span>
    <div class="flex-1">
      <p class="text-[13px] text-[var(--base-text-alt-dark)] m-0">{{problem.message}}</p>
      <p *ngIf="locationOf(problem)" class="text-[12px] opacity-70 m-0 mt-1">{{locationOf(problem)}}</p>
    </div>
  </div>
</div>

<p *ngIf="hiddenCount" class="text-[12px] opacity-70 m-0 mb-4">and {{hiddenCount}} more</p>
